<template>
  <div class="user-transactions" :class="{'p-3': userId > 0}">
    <draggable-dynamic-table ref="userTransactions"
                             class="user-transactions"
                             :in-modal="userId > 0"
                             :options="options"
                             :columns="columnsLabel"
                             :data="data"
                             @load:more="getUserTransactions()"/>

    <button id="printUserTransactions" v-show="false" @click="handlePrintUserTransactions"></button>
  </div>
</template>

<script>
import DraggableDynamicTable from '@/components/draggableDynamicTable/draggableDynamicTable'
import {getUser, getUserTransaction, printUserTransactions} from '@/http/requests/users/users'
import {getTimeFromServer, hideLoading, showLoading} from "../../../../assets/js/functions";

export default {
  name: 'userTransactions',
  components: {DraggableDynamicTable},
  metaInfo () {
    return {
      title: this.user ? this.$t('users.transactions.dynamicTitle', {name: `${this.user.name} ${this.user.family}`}) : this.$t('users.transactions.title')
    }
  },
  props: {
    userId: 0
  },
  data () {
    return {
      requestSent: false,
      options: {
        id: 'userTransactions',
        rowKeyField: 'docNumber'
      },
      columnsLabel: [
        {
          field: 'balance',
          i18n: 'users.transactions.table.header.balance',
          width: '130px',
          minWidth: 130,
          locked: true,
          // sortable: true
        },
        {
          field: 'price',
          i18n: 'users.transactions.table.header.price',
          width: '130px',
          minWidth: 130,
          locked: true,
          // sortable: true
          /*footer: {
            type: 'auto-sum',
            textType: 'price'
          }*/
        },
        {
          field: 'documentation',
          i18n: 'users.transactions.table.header.documentation',
          width: '120px',
          minWidth: 120,
          align: 'center',
          locked: true,
          // sortable: true
        },
        {
          field: 'date',
          i18n: 'users.transactions.table.header.date',
          align: 'center',
          width: '70px',
          minWidth: 70,
          locked: true,
          // sortable: true
        },
        {
          field: 'docNumber',
          i18n: 'users.transactions.table.header.docNumber',
          width: '80px',
          minWidth: 80,
          align: 'center',
          locked: true,
          // sortable: true
          /*footer: {
            type: 'auto-counter',
          }*/
        }
      ],
      user: null,
      data: [],
      filters: [],
      sorts: ['order[0]=created_at,desc'],
      page: 1,
      loadingTimer: 0,
      endedList: false,
      actions: [
        {
          leftToolbar: [
            {
              id: 'printTable',
              icon: 'icon-printer',
              iconPack: 'feather'
            },
            {
              id: 'downloadTable',
              icon: 'icon-download',
              iconPack: 'feather'
            },
            {
              id: {name: 'user', params: {id: this.$route.params.id}},
              type: 'link',
              icon: 'icon-chevron-left',
              iconPack: 'feather'
            }
          ]
        }
      ]
    }
  },
  created () {
    if (this.userId === 0) {
      setTimeout(() => {
        this.$store.dispatch('updateNavbarActions', this.actions[0])
        this.$store.dispatch('updateContentNavbarStyle', 'sticky')
      }, 50)
    }

    getUser(this.userId || this.$route.params.id).then(response => {
      this.user = response.data.data
      if (!this.userId) this.$store.dispatch('setPageTitle', this.$t('users.transactions.dynamicTitle', {name: `${this.user.name} ${this.user.family}`}))
    })

    this.getUserTransactions()
  },
  methods: {
    getUserTransactions () {
      if (!this.requestSent) {
        this.requestSent = true

        clearTimeout(this.loadingTimer)
        this.loadingTimer = setTimeout(() => {
          if (!this.endedList) {
            if (this.$refs.userTransactions && this.data.length === 0) {
              this.$refs.userTransactions.loadMoreStatus = 'FirstLoad'
            } else if (this.$refs.userTransactions && this.data.length > 0) {
              this.$refs.userTransactions.loadMoreStatus = 'Loading'
            }

            getUserTransaction(this.userId || this.$route.params.id, this.page, this.filters, this.sorts).then(response => {
              this.endedList = response.data.data.length === 0

              const userTransactions = response.data.data
              userTransactions.forEach((transaction) => {
                this.data.push({
                  docNumber: transaction.document.id,
                  date: transaction.created_at,
                  documentation: transaction.document.description,
                  price: {
                    type: transaction.price !== 0 ? 'price' : 'number',
                    classes: transaction.price > 0 ? 'text-danger' : transaction.price === 0 ? 'text-primary' : 'text-success',
                    value: transaction.price ? Math.abs(transaction.price) : 0
                  },
                  balance: {
                    type: transaction.balance !== 0 ? 'price' : 'number',
                    classes: transaction.balance > 0 ? 'text-danger' : transaction.balance === 0 ? 'text-primary' : 'text-success',
                    value: transaction.balance ? Math.abs(transaction.balance)  : 0
                  },
                  route: transaction.document.reference_type !== '' ? this.getDocumentReferenceRoute(transaction, transaction.document.reference) : {}
                })
              })

              this.page = response.data.pagination.current_page + 1
              if (response.data.pagination.current_page === 1) {
                const row_index = this.columnsLabel.map((e) => {
                  return e.field
                }).indexOf('docNumber')

                this.columnsLabel[row_index].footer = {value: response.data.pagination.total}
              }

              if (this.$refs.userTransactions) this.$refs.userTransactions.loadMoreStatus = ''
              this.requestSent = false
            }).catch((error) => {
              if (this.$refs.userTransactions) this.$refs.userTransactions.loadMoreStatus = 'Danger'
              this.requestSent = false
            })
          } else {
            this.requestSent = false
          }
        }, 500)
      }
    },
    getDocumentReferenceRoute (transaction, reference) {
      switch (transaction.document.reference_type) {
      case 'Invoice':
        const mapper = {
          '1': 'saleInvoice',
          '2': 'purchaseInvoice',
          '3': 'returnSaleInvoice',
          '4': 'returnPurchaseInvoice',
          '5': 'treasuryReceiveDocument'
        }
        let type = 1
        switch (transaction.document.type) {
          case this.$t('users.transactions.types.sale'):
            type = 1
            break

          case this.$t('users.transactions.types.purchase'):
            type = 2
            break

          case this.$t('users.transactions.types.receive'):
            type = 5
            break
        }
        return {name: mapper[type], params: {id: reference.id}, target: '_blank'}

      case 'OpeningInventory':
        return {name: 'openingBalance'}

      default:
        return {}
      }
    },

    handlePrintUserTransactions () {
      showLoading()

      printUserTransactions(this.userId || this.$route.params.id, this.filters, this.sorts).then(response => {
        hideLoading()

        const data = response.data

        let time = getTimeFromServer()
        let fileURL = window.URL.createObjectURL(new Blob([data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `userTransactionList-${ time }.pdf`);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
        .catch((error) => {
          hideLoading()

          if (axios.isCancel(error)) {
            this.$vs.notify({
              title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: 2400,
              color: 'warning'
            })
          } else {
            this.$vs.notify({
              title: this.$t('alert.message.title'),
              text: this.$t('users.transactions.notifications.print.error'),
              color: 'danger',
              time: 2400,
              icon: 'icon-alert-circle',
              iconPack: 'feather'
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-transactions {
  height: 100%;
}
</style>
